import { Button, Stack } from 'components';
import aiScribeBackgroundIntro from 'assets/png/aiScribeBackgroundIntro.png';
import { useAiScribeContext } from 'modules/aiScribe/context/useAiScribe';

import style from './idleScreen.module.scss';

const IdleScreen = () => {
  const { startRecording, handleDrawerClose } = useAiScribeContext();
  return (
    <Stack height="100%" width="100%">
      <img src={aiScribeBackgroundIntro} className={style.backgroundIntro} />
      <Stack
        position="relative"
        display="flex"
        flexDirection="column"
        justifyContent="space-between"
        height="100%"
      >
        <h2 className={style.title}>AI Scribe</h2>
        <Stack
          display="flex"
          flexDirection="column"
          justifyContent="center"
          alignItems="center"
          gap="40px"
          width="100%"
        >
          <p className={style.description}>Is your client OK with being recorded?</p>
          <Stack
            width="100%"
            display="flex"
            flexDirection="row"
            justifyContent="center"
            alignItems="center"
            gap="16px"
          >
            <Button
              text="Cancel"
              theme="transparent"
              handleOnClick={() => handleDrawerClose()}
              customStyleClass={style.cancelButton}
            />
            <Button
              text="Yes, continue"
              theme="primary"
              handleOnClick={() => startRecording({ noteType: '' })}
            />
          </Stack>
        </Stack>
      </Stack>
    </Stack>
  );
};

export default IdleScreen;
